import type { IOrganizationCommissionLimitsAssetFinance } from './OrganizationCommissionLimitsAssetFinance.interface';

export default class OrganizationCommissionLimitsAssetFinance
  implements IOrganizationCommissionLimitsAssetFinance {
  minimumFee: number;
  commissionPercentage: number;
  thresholdCommissionValue: number;
  isSharedWithBrokers: boolean;

  static build = (data: IOrganizationCommissionLimitsAssetFinance) =>
    new OrganizationCommissionLimitsAssetFinance(data);

  static blank = () => new OrganizationCommissionLimitsAssetFinance();

  /**
   * Constructor
   * @param {IOrganizationCommissionLimitsAssetFinance} data
   */
  constructor(data?: IOrganizationCommissionLimitsAssetFinance) {
    this.minimumFee = parseFloat(data?.minimumFee || 0);
    this.commissionPercentage = parseFloat(data?.commissionPercentage || 0);
    this.thresholdCommissionValue = parseFloat(data?.thresholdCommissionValue || 0);
    this.isSharedWithBrokers = data?.isSharedWithBrokers === true;
  }
}
